import { Direction } from "@lytra/frontend-common/__generated__/graphql";
import { isInternalRow } from "./noteThreads";

/** Which side of the ticket thread a row sits on, chat-style: the customer left, we right. */
export type ThreadSide = "start" | "end";

/**
 * The side of a thread row: the customer's mail on the start side, everything from our side on
 * the end side, both our replies to the customer and what stays internal (notes, sends to
 * colleagues and their mail replies, staff-to-staff and connector notes). A row of no known
 * direction counts as the customer's.
 */
export function threadSide(message: {
  direction?: Direction | null;
  isNote?: boolean | null;
  isForward?: boolean | null;
  isInternal?: boolean | null;
}): ThreadSide {
  if (message.isNote || message.isForward || isInternalRow(message)) {
    return "end";
  }
  return message.direction === Direction.Outbound ? "end" : "start";
}

/** Pushes a row to its side; the width cap leaves the other side a visible gap. */
export const THREAD_SIDE_CLASS: Record<ThreadSide, string> = {
  start: "mr-auto",
  end: "ml-auto",
};

/** A row's width cap: 85% of the column, and never past a readable line length. */
export const THREAD_ROW_WIDTH = "max-w-[min(85%,65ch)]";
